import { Editor, Element, Node, Path, Range } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

const types = serializer.types;
const layoutUtilities = serializer.utilities.node.layout;

function findCell(editor, path) {

  for (const [ancestor, ancestorPath] of Node.ancestors(editor, path, { reverse: true })) {
    if (ancestor.type === types.LAYOUT) {
      return { layout: ancestor, layoutPath: ancestorPath, itemPath: path.slice(0, ancestorPath.length + 1) };
    }
  }

  return null;

}

export function findNearestLayout(editor, path) {

  for (const entry of Node.ancestors(editor, path, { reverse: true })) {
    if (entry[0].type === types.LAYOUT) {
      return entry;
    }
  }

  return null;

}

function isSamePath(first, second) {

  if (first === null || second === null) {
    return first === second;
  }

  return Path.equals(first, second);

}

// Whether text moving between two points would cross into or out of a layout, or between the
// items of a row. Inside a stack, blocks merge as they do anywhere else.
export function crossesLayoutItem(editor, fromPath, toPath) {

  const from = findCell(editor, fromPath);
  const to = findCell(editor, toPath);

  if (from === null || to === null) {
    return from !== to;
  }

  if (isSamePath(from.layoutPath, to.layoutPath) === false) {
    return true;
  }

  return layoutUtilities.isRowLayout(from.layout) === true && Path.equals(from.itemPath, to.itemPath) === false;

}

function isBlockElement(editor, node) {
  return Element.isElement(node) === true && Editor.isBlock(editor, node) === true;
}

// The lowest block holding a collapsed caret, unless it is a void.
export function findCaretBlock(editor) {

  if (editor.selection === null || Range.isCollapsed(editor.selection) === false) {
    return null;
  }

  const entry = Editor.above(editor, { match: isBlockElement.bind(null, editor), mode: 'lowest' });

  if (typeof entry === 'undefined' || Editor.isVoid(editor, entry[0]) === true) {
    return null;
  }

  return entry;

}
